import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsTHandlingLogAssignmentOrderNewPlanEvent } from "../../../common/types/order-details-handling-log-entry-event";

const getTaxiCorporationName = (
  taxiCorporationName: OrderDetailsTHandlingLogAssignmentOrderNewPlanEvent["taxiCorporationName"],
) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .assignmentOrderNewPlan.taxiCorporationNameLabel;

  return translations.replace(
    "#{taxiCorporationName}",
    taxiCorporationName ?? "-----",
  );
};

const getDriverName = (
  driverName: OrderDetailsTHandlingLogAssignmentOrderNewPlanEvent["driverName"],
) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .assignmentOrderNewPlan.driverNameLabel;

  return translations.replace("#{driverName}", driverName ?? "-----");
};

const orderDetailsHistoryEntryAssignmentOrderNewPlanContentHelper = {
  getTaxiCorporationName,
  getDriverName,
};

export default orderDetailsHistoryEntryAssignmentOrderNewPlanContentHelper;
